import * as React from 'react';

export function Divider({ ...props }) {
  return (
    <div className="relative z-10">
      <div className="absolute w-full h-px bg-divider" {...props} />
    </div>
  );
}
